import React from 'react';

import SimpleCollapse from '../../agent/components/SimpleCollapse';

import type { ItemRepresentation, SerializedRegistry } from 'js/src/agent/registries/BaseRegistry';
import Tooltip from 'js/src/components/common/ui/Tooltip';

type AudioRepresentation = ItemRepresentation & { duration?: number };

interface AudioRegistryDisplayProps {
    title: string;
    emoji: string;
    registry: SerializedRegistry<AudioRepresentation> | null;
}

const AudioRegistryDisplay: React.FC<AudioRegistryDisplayProps> = ({ title, emoji, registry }) => {
    const items = registry?.items ?? [];
    if (items.length === 0) {
        return null;
    }

    return (
        <div className="mt-l5-16">
            <SimpleCollapse
                title={
                    <div className="d-flex align-items-center">
                        <span className="me-l5-4" style={{ fontSize: '20px' }}>
                            {emoji}
                        </span>
                        <span className="fw-semibold">
                            {title} ({items.length} items)
                        </span>
                    </div>
                }
                defaultExpanded={false}
            >
                <div className="p-l5-8 d-flex flex-wrap gap-3">
                    {items.map((item) => {
                        const { tags, title: itemTitle, duration } = item.representation;
                        return (
                            <Tooltip key={item.id} title={tags || undefined}>
                                <div
                                    className="rounded border p-l5-8 d-flex flex-column text-center"
                                    key={item.id}
                                >
                                    {item.id}
                                    <span className="fw-semibold">{itemTitle}</span>
                                    {duration != null && (
                                        <span className="text-muted small">{duration}s</span>
                                    )}
                                </div>
                            </Tooltip>
                        );
                    })}
                </div>
            </SimpleCollapse>
        </div>
    );
};

export default AudioRegistryDisplay;
